import {addGenericErrorToast} from '@albert-io/atomic';
import {getStudentQuery} from 'client/Classrooms/StudentDashboard/StudentDashboard.queries.js';
import {useStudentHomepageStore} from '../useStudentHomepageStore';

export default function useGetStudent() {
  const isStudentLoading = useStudentHomepageStore((state) => state.studentEmail === null);
  const setStudentEmail = useStudentHomepageStore((state) => state.setStudentEmail);

  function fetchStudent() {
    getStudentQuery()
      .getResourcePromise()
      .then((fetchedStudent) => {
        setStudentEmail(fetchedStudent.getEmail());
      })
      .catch((error) => {
        console.error(error);
        addGenericErrorToast();
      });
  }

  return {fetchStudent, isStudentLoading};
}
